const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getAlertThresholds(orgId, filters = {}) {
  const params = new URLSearchParams();
  
  if (filters.programId) params.append('programId', filters.programId);
  if (filters.siteId !== undefined) params.append('siteId', filters.siteId);
  if (filters.thresholdType) params.append('thresholdType', filters.thresholdType);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/config/alert-thresholds${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view alert thresholds');
    }
    throw new Error('Failed to fetch alert thresholds');
  }
  
  const data = await response.json();
  return data.thresholds;
}

export async function getAlertThreshold(orgId, thresholdId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/alert-thresholds/${thresholdId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Threshold not found');
    }
    throw new Error('Failed to fetch threshold');
  }
  
  const data = await response.json();
  return data.threshold;
}

export async function getEffectiveThreshold(orgId, programId, siteId, thresholdType) {
  const params = new URLSearchParams({
    programId,
    thresholdType
  });
  if (siteId) params.append('siteId', siteId);
  
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/alert-thresholds/effective?${params}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch effective threshold');
  }
  
  const data = await response.json();
  return data.threshold;
}

export async function createAlertThreshold(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/alert-thresholds`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create alert thresholds');
    }
    throw new Error('Failed to create threshold');
  }
  
  const result = await response.json();
  return result.threshold;
}

export async function updateAlertThreshold(orgId, thresholdId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/alert-thresholds/${thresholdId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to update alert thresholds');
    }
    if (response.status === 404) {
      throw new Error('Threshold not found');
    }
    throw new Error('Failed to update threshold');
  }
  
  const result = await response.json();
  return result.threshold;
}

export async function getThresholdVersions(orgId, thresholdId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/alert-thresholds/${thresholdId}/versions`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Threshold not found');
    }
    throw new Error('Failed to fetch threshold versions');
  }
  
  const data = await response.json();
  return data.versions;
}
